import {
  AWAITING_DOCUMENTS_FROM_CITIZEN,
  APPROVED_AWAITING_COLLECTION,
  BEING_EDITED,
  INITIAL_SUBMIT,
  PHOTOFORREFERRAL,
  RESUBMITTED,
  TEMPORARILY_SAVED,
  FOR_REJECT,
  REJECTED_FROM_CITIZEN,
  MEDICAL_A_DEGREE_REJECTION,
  REVIEW,
  REJECTED_FROM_SERVICE,
  FINISHED,
} from "../../../constants";

import { Card, CardContent, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { FieldArray, useFormikContext } from "formik";
import useLocale from "../../../hooks/useLocale";

import { sortOrderDocs } from "../../../utils/sortOrderDocuments";

import FileUpload from "../../../components/GovGrFileInput/FileUpload";
import handleImageUpload from "./handleImageUpload";
import handleFileUpload from "./handleFileUpload";
import { Buffer } from "buffer";

const useStyles = makeStyles({
  root: {
    "& .MuiTextField-root": {
      margin: 15,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
    },
  },
  card: {
    minWidth: 275,
    marginTop: 15,
    marginBottom: 15,
    alignSelf: "center",
  },
  viewDetails: {
    width: 700,
    height: 400,
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
  },
  cardContent: {
    marginTop: 15,
    marginBottom: 15,
  },
  documentsWrapper: {},
  uploadButton: {
    margin: "1rem 0",
  },
  button: {
    margin: "1rem",
  },
});

const UploadedDocuments = React.memo(
  ({ docsPerKind, disableAll, status, initiallyUploadedDocuments }) => {
    const { t } = useLocale();
    const classes = useStyles();
    const [uploadedDocumentsIds, setUploadedDocumentsIds] = useState([]);
    const [imageFormatErrorText, setImageFormatErrorText] = useState("");
    const { values } = useFormikContext();

    useEffect(() => {
      // console.log(status);
      // console.log(values.id);
      // console.log(values);
      // console.log(values.uploadedDocuments);
      setUploadedDocumentsIds(
        values.uploadedDocuments?.map((doc) => doc.doc_id)
      );
    }, [values.uploadedDocuments]);
    const docsPerKindSorted = sortOrderDocs(docsPerKind);
    return (
      <Card className={classes.card}>
        <CardContent className={classes.cardContainer}>
          <FieldArray
            name="uploadedDocuments"
            render={(arrayHelpers) => (
              <div className={classes.documentsWrapper}>
                {docsPerKindSorted?.map((docPerKind, index) => {
                  // console.log(doc);
                  // This finds the uploaded document that corresponts with the
                  // current docPerKind
                  const currentDocument = values.uploadedDocuments?.find(
                    (doc) => doc?.doc_id === docPerKind.doc_id
                  );


                  // console.log(doc);
                  console.log("index", index ,currentDocument,  "currentDocument");
                  const initialDocument = initiallyUploadedDocuments?.find(
                    (doc) => doc?.doc_id === docPerKind.doc_id
                  );

                  let disableViewButton = !currentDocument || status === APPROVED_AWAITING_COLLECTION || status === BEING_EDITED || status === RESUBMITTED || status === APPROVED_AWAITING_COLLECTION || status === REJECTED_FROM_SERVICE
                   


                  let disableDeleteButton = !currentDocument?.new && initialDocument?.sts_flg !== 2;


                  if (!disableViewButton) {
                    // console.log("initialDocument");
                    // console.log(initialDocument);
                    if (initialDocument?.modifiedat_by === 'admin' && initialDocument?.amka_afora !== initialDocument?.amka_ait) {
                      disableViewButton = true;
                    }

                  }

                  if (!disableDeleteButton) {
                    if (initialDocument?.modifiedat_by === 'admin') {
                      disableDeleteButton = true;
                    }
                  }

                  const isPhoto = docPerKind?.document.includes(PHOTOFORREFERRAL);

                  const error =
                    initialDocument?.reason_txt ||
                    (imageFormatErrorText && isPhoto && imageFormatErrorText) ||
                    (docPerKind.req_flg === 1 &&
                      !uploadedDocumentsIds?.includes(docPerKind.doc_id) &&
                      t("Required"));

                  {
                    /* const disabled = !(
                    disableAll ||
                    status === RESUBMITTED ||
                    status === INITIAL_SUBMIT ||
                    status === TEMPORARILY_SAVED ||
                    (initialDocument?.sts_flg === 2 && !currentDocument)
                  ); */
                  }
                  const disabled = false;
                  /* // console.log(values.uploadedDocuments); */

                  const disabledDoc = () => {
                    // return false;
                    if (initialDocument?.modifiedat_by === 'admin' && initialDocument?.amka_afora !== initialDocument?.amka_ait || status === APPROVED_AWAITING_COLLECTION || status === BEING_EDITED || status === RESUBMITTED || status === APPROVED_AWAITING_COLLECTION || status === FOR_REJECT || status === REJECTED_FROM_CITIZEN || status === MEDICAL_A_DEGREE_REJECTION ||  status === REVIEW || status === REJECTED_FROM_SERVICE || status === FINISHED ) {
                      return true;
                    } else {
                      return false;
                    }
                  }


                  return (
                    <Card
                      key={docPerKind.id}
                      variant="outlined"
                      className={classes.cardContent}
                    >
                      <CardContent>
                        <FileUpload
                          label={`${index + 1}. ${docPerKind.dscr}`}
                          document={currentDocument}
                          accept={
                            isPhoto ? "image/*" : "application/pdf,image/jpeg"
                          }
                          hint={isPhoto && t("Photo Requirements")}
                          errorLabel={error}
                          handleViewFile={() => {
                            if (currentDocument.new) {
                              const blob = new Blob(
                                [currentDocument?.files[0]],
                                {
                                  type: currentDocument?.files[0].type,
                                }
                              );
                              // console.log("view file");
                              // console.log(blob)
                              let url = window.URL.createObjectURL(blob);
                              // console.log(url);
                              window.open(url, "_blank");
                            } else {
                              if (currentDocument?.doc_data?.data) {
                                const blob = new Blob(
                                  [
                                    Buffer.from(
                                      currentDocument?.doc_data?.data
                                    ),
                                  ],
                                  {
                                    type: "application/pdf",
                                  }
                                );
                                // console.log("view file new 1");
                                // console.log(currentDocument?.doc_data?.data);
                                // console.log(blob);
                                let url = window.URL.createObjectURL(blob);
                                // console.log(url);
                                window.open(url, "_blank");
                              }
                            }
                          }}
                          handleDeleteFile={() => {
                            const foundDocIndex =
                              values?.uploadedDocuments?.findIndex(
                                (uploadedDoc) =>
                                  uploadedDoc.doc_id === docPerKind.doc_id
                              );

                            arrayHelpers.remove(foundDocIndex);
                          }}
                          onChange={(e) =>
                            isPhoto
                              ? handleImageUpload(
                                e,
                                values,
                                docPerKind,
                                setImageFormatErrorText,
                                arrayHelpers,
                                t
                              )
                              : handleFileUpload(
                                e,
                                values,
                                docPerKind,
                                arrayHelpers
                              )
                          }

                          disableViewButton={disableViewButton}
                          disabled={disabledDoc()}
                          disableDeleteButton={disableDeleteButton}
                          uploadedFilename={values?.uploadedDocuments
                            ?.filter((doc) => doc.doc_id === docPerKind.doc_id)
                            ?.map((doc) => {
                              if (!doc.new) {
                                return (
                                  <p key={doc.file_name}>{doc.file_name}</p>
                                );
                              } else {
                                return doc.files.map((file) => (
                                  <p key={file.name}>{file.name}</p>
                                ));
                              }
                            })}
                        />
                      </CardContent>
                    </Card>
                  );
                })}
              </div>
            )}
          />
        </CardContent>
      </Card>
    );
  }
);

export default UploadedDocuments;
